// Basic token helper used by API handlers. Update to your auth storage as needed.
export const getToken = async () => {
  if (typeof localStorage === 'undefined') return '';
  return localStorage.getItem('token') || '';
};
